import React, { useEffect, useState } from 'react'
import { Tabs } from 'antd'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { FaUserCircle, FaShieldAlt, FaSlidersH, FaEnvelope, FaBuilding, FaPhoneAlt, FaCalendarAlt } from 'react-icons/fa'
import moment from 'moment'
import Profile from './Profile'
import Security from './Security'
import Preferences from './Preferences'
import { verifyToken } from '../../utils/helpers'
import { translations } from '../../utils/constants'

// Human labels for the stored role values.
export const ROLE_LABELS = { superAdmin: 'Super Admin', admin: 'Admin', user: 'User' }

// Two-letter monogram used wherever the user has no photo.
export const userInitials = (name, email) => {
  const source = String(name || email || '').trim()
  if (!source) return 'U'
  const parts = source.split(/[\s._-]+/).filter(Boolean)
  return parts.slice(0, 2).map((p) => p[0]).join('').toUpperCase()
}

const Settings = ({ language }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const { TabPane } = Tabs
  const user = useSelector((state) => state?.authReducer?.user)
  const [activeTab, setActiveTab] = useState('1')

  useEffect(() => {
    verifyToken(history, dispatch)
    if (location.state?.activeTab) {
      setActiveTab(String(location.state.activeTab))
    }
  }, [location.state]) // eslint-disable-line

  const t = translations[language] || {}
  const memberSince = user?.createdAt && moment(user.createdAt).isValid()
    ? moment(user.createdAt).format('DD MMM YYYY')
    : '-'

  return (
    <div className='main-container'>
      <div className='main-inner-container'>
        <div className='ps-header'>
          <h1 className='main-heading margin-bottom-0'>{t.profileSettings || t.settingHeading}</h1>
          <p className='ps-header-sub'>{t.profileSubtitle}</p>
        </div>

        <div className='ps-layout'>
          {/* Identity card: what everyone else sees of this account. */}
          <aside className='ps-card ps-identity'>
            <div className='ps-identity-avatar'>
              {user?.profileImage ? (
                <img src={user.profileImage} alt={user?.username || 'avatar'} />
              ) : (
                <span>{userInitials(user?.username, user?.email)}</span>
              )}
            </div>
            <h2 className='ps-identity-name capitalized-name'>{user?.username || '-'}</h2>
            <span className={`ps-role-badge ps-role-${user?.role || 'user'}`}>
              {ROLE_LABELS[user?.role] || user?.role || '-'}
            </span>
            <div className='ps-identity-rows'>
              <div className='ps-identity-row'>
                <FaEnvelope />
                <span className='text-ellipsis' title={user?.email}>{user?.email || '-'}</span>
              </div>
              <div className='ps-identity-row'>
                <FaPhoneAlt />
                <span>{user?.phonenumber || '-'}</span>
              </div>
              <div className='ps-identity-row'>
                <FaBuilding />
                <span className='capitalized-name text-ellipsis'>{user?.organization || '-'}</span>
              </div>
              <div className='ps-identity-row'>
                <FaCalendarAlt />
                <span>{t.memberSince}: {memberSince}</span>
              </div>
            </div>
          </aside>

          <section className='ps-card ps-content'>
            <Tabs activeKey={activeTab} onChange={setActiveTab} className='ps-tabs'>
              <TabPane
                key='1'
                tab={<span className='ps-tab-label'><FaUserCircle /> {t.profilerSetting}</span>}
              >
                <Profile language={language} />
              </TabPane>
              <TabPane
                key='2'
                tab={<span className='ps-tab-label'><FaShieldAlt /> {t.securityfleSetting}</span>}
              >
                <Security language={language} />
              </TabPane>
              <TabPane
                key='3'
                tab={<span className='ps-tab-label'><FaSlidersH /> {t.preferences}</span>}
              >
                <Preferences language={language} />
              </TabPane>
            </Tabs>
          </section>
        </div>
      </div>
    </div>
  )
}

export default Settings
